export interface ApiConfig {
  baseUrl: string
  graphqlEndpoint: string
  timeout: number
  retries: number
  retryDelay: number
}

export interface GraphQLConfig {
  uri: string
  headers?: Record<string, string>
  credentials?: 'include' | 'same-origin' | 'omit'
  cache?: 'default' | 'no-cache' | 'reload' | 'force-cache' | 'only-if-cached'
  timeout: number
}

export const createApiConfig = (): ApiConfig => ({
  baseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000',
  graphqlEndpoint: import.meta.env.VITE_GRAPHQL_ENDPOINT || '/graphql',
  timeout: parseInt(import.meta.env.VITE_API_TIMEOUT || '100000', 10), // Increased to 100 seconds for Cloudflare limit
  retries: parseInt(import.meta.env.VITE_API_RETRIES || '5', 10), // Increased retries
  retryDelay: parseInt(import.meta.env.VITE_API_RETRY_DELAY || '2000', 10), // Increased delay between retries
})

export const createGraphQLConfig = (apiConfig: ApiConfig): GraphQLConfig => ({
  uri: `${apiConfig.baseUrl}${apiConfig.graphqlEndpoint}`,
  credentials: 'include',
  cache: 'no-cache',
  timeout: apiConfig.timeout,
})
